<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="handData",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="培训ID" prop="matchId")
                    div.width_label {{handData.trainCode}}
                el-form-item(label="培训名称" prop="matchName")
                    div.width_label {{handData.name}}
                el-form-item(label="培训类型")
                    div.width_label {{pxType[handData.type]}}
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{handData.orgName}}
                el-form-item(label="培训场地")
                    div.width_label {{handData.placesName}}
                br
                el-form-item(label="级别" prop="level")
                        div.width_label {{handData.level}}
                el-form-item(label="班级人数" prop="classCount")
                        div.width_label {{nowPerNum}}/{{handData.classCount}}
                el-form-item(label="培训时间")
                        div.width_label {{handData.trainStartTime}}
                el-form-item(label="状态")
                    div.width_label {{pxState[handData.state]}}
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 参训人员
                      div
                        el-table(:data="enrollDataOne" border @selection-change="enrollOneChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column(prop="mobile" label="会员账号" align='center' width="130")
                                el-table-column(prop="gender" label="性别" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="60")
                                el-table-column(prop="type" label="会员类型" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.type == 1") 注册会员
                                        font(v-if="scope.row.type == 2") 初始会员
                                        font(v-if="scope.row.type == 3") 荣誉会员
                                el-table-column(prop="classCode" label="参加课程" align='center')
                                el-table-column(prop="byx2" label="代报名" align='center')
                                    template(slot-scope="scope")
                                        font() {{{0:'否',1:'是'}[scope.row.byx2]}}
                                el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未支付
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 支付成功
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payType" label="支付方式" align='center')
                                    template(slot-scope="scope")
                                        font() {{payType[scope.row.payType]}}
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{scope.row.payAmount}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null") ￥{{scope.row.refundFee}}元
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" @click="lookChildren(scope.row.id)" :disabled="scope.row.byx2!=='1'") 查看青少年
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 插班人员
                      div
                        el-table(:data="enrollDataThree" border )
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column(prop="mobile" label="会员账号" align='center' width="130")
                                el-table-column(prop="gender" label="性别" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="60")
                                el-table-column(prop="type" label="会员类型" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.type == 1") 注册会员
                                        font(v-if="scope.row.type == 2") 初始会员
                                        font(v-if="scope.row.type == 3") 荣誉会员
                                el-table-column(prop="classCode" label="参加课程" align='center')
                                el-table-column(prop="byx2" label="代报名" align='center')
                                    template(slot-scope="scope")
                                        font() {{{0:'否',1:'是'}[scope.row.byx2]}}
                                el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未支付
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 支付成功
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payType" label="支付方式" align='center')
                                    template(slot-scope="scope")
                                        font() {{payType[scope.row.payType]}}
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{scope.row.payAmount}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null") ￥{{scope.row.refundFee}}元
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" @click="lookChildren(scope.row.id)" :disabled="scope.row.byx2!=='1'") 查看青少年
            el-row(style="padding-top:10px")
                el-col(:span="24")
                    el-button(type="primary" @click="orderExportExcel") 订单明细
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 订单详情
                        //- el-button.btn_style(type="primary" @click="orderExportExcel") 名单导出
                      div
                        el-table(:data="orderInfoData" border)
                                el-table-column(prop="orderUserName" label="姓名" align='center')
                                el-table-column(prop="account" label="会员账号" align='center')
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundAmount !== null") ￥{{parseFloat(scope.row.refundAmount).toFixed(2)}}元
                                el-table-column(prop="payStatus" label="状态" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未支付
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 支付成功
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
            el-dialog(title="查看青少年" :visible.sync='lookinfoChildren' :append-to-body='true' :modal-append-to-body='false')
                el-table(:data="childrenData" border max-height="300" style='margin-top:20px')

                    el-table-column(prop="name" label="姓名" align='center')
                    el-table-column(prop="sex" label="性别" align='center' )
                        template(slot-scope="scope")
                            font(v-if="scope.row.sex === 0") 男
                            font(v-if="scope.row.sex === 1") 女
                    el-table-column(prop="age" label="年龄" align='center')
                    el-table-column(prop="level" label="级别" align='center' )
                    el-table-column(prop="height" label="身高" align='center' )
                    el-table-column(prop="relation" label="关系" align='center' )
                        template(slot-scope="scope")
                            font() {{relationOptions[scope.row.relation]}}
                span.dialog-footer(slot="footer")
                    el-button(@click="lookinfoChildren=false") 返 回
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回

</template>
<script>
import commonData from './tabletr.js'
import table from './orderTable.js'

export default {
    data() {
        return {
            refundBtn: false,
            isDesabled: false,
            relationOptions: commonData.relationOptions,
            pxLevel: commonData.pxLevel,
            pxState: commonData.pxState2,
            pxType: commonData.pxType,
            payType: commonData.payType,
            handData: '', //头部回显
            trainPersonList: {}, //请求添加人员数据
            trainId: '', //培训id
            isCollapse: true,
            lookinfoChildren: false,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            buttonSize: 'large',
            options: [],
            nowPerNum: 0,
            visible: false,
            title: '培训人员',
            enrollData: [],
            enrollDataOne: [],
            enrollDataThree: [],
            childrenData: [],
            orderInfoData: [],
            type: '',
            busCategory: ''

        }
    },
    methods: {

        getNowPerson() {
            this.$http({
                url: this.$http.adornUrl(`/pxTrain/queryByTrainNum/${this.trainId}`),
                method: 'post'
            }).then(res => {
                this.handData = res.data
                this.nowPerNum = this.handData.joinCount
                if (this.nowPerNum >= this.handData.classCount && this.handData.bench === 1) {
                    this.stateName = '报满可替'
                } else if (this.nowPerNum >= this.handData.classCount && this.handData.bench === 0) {
                    this.stateName = '已报满'
                } else {
                    this.stateName = ''
                }
            }).then(() => {
                this.getInfoData()

            })
        },
        uopdatePersonList() {
            this.getTrainPerson(1)
            this.getTrainPerson(3)
        },
        //查看青少年
        lookChildren(id) {
            this.childrenData = []
            this.lookinfoChildren = true
            this.$http({
                url: this.$http.adornUrl(`/pxTrainInstead/getTrainId/${id}`),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.childrenData = data.list
                }
            })
        },

        //查询参训人员列表 状态（1参训人员、2替补人员 3插班人员）
        getTrainPerson(state) {
            this.$http({
                url: this.$http.adornUrl(`/pxTrainPerson/list`),
                method: 'post',
                data: {
                    page: this.pageIndex,
                    limit: 99999,
                    trainId: this.trainId,
                    state: state
                }
            }).then((data) => {
                if (data && data.code === 0) {
                    if (state === 1) {
                        this.getNowPerson()
                        this.enrollDataOne = data.page.records
                    } else if (state === 3) {
                        this.enrollDataThree = data.page.records
                    }
                    this.totalPage = data.page.total
                }
            })
        },
        init(id, type, busCategory) {
            this.trainId = id || ''
            this.type = type
            this.busCategory = busCategory
            this.visible = true
            this.enrollData = []
            this.enrollDataOne = []
            this.enrollDataThree = []
            this.uopdatePersonList()
        },
        getInfoData() {
            this.$http({
                url: this.$http.adornUrl('/frFranchiseFeeRecord/queryCtPxOrderList'),
                method: 'post',
                data: {
                    busId: this.handData.trainCode,
                    ctPxId: this.handData.id,
                    // orderType: this.handData.type
                    orderType: this.type,
                    busCategory: this.busCategory
                }
            }).then(res => {
                console.log(res)
                this.orderInfoData = res.data

            })
        },
        orderExportExcel() {
            this.$http({
                url: this.$http.adornUrl('/frFranchiseFeeRecord/exportCtPxOrderList'),
                method: 'post',
                data: {
                    busId: this.handData.trainCode,
                    ctPxId: this.handData.id,
                    // orderType: this.handData.type
                    orderType: this.type,
                    busCategory: this.busCategory
                }
            }).then(data => {
                if (data && data.code === 0) {
                    if (data.list == null || data.list.length === 0) {
                        this.$message.info('没有要导出的数据!')
                        return
                    }
                    let exportData = data.list
                    this.$export.excel({
                        columns: table.columns,
                        data: exportData,
                        title: '订单详情'
                    }).then(() => {
                        this.$message.success('导出表格成功')
                    })
                }


            })

        }

    }
}
</script>
<style>
.width_label {
    width: 180px;
}

.opSetting {
    text-align: center;
    margin-top: 30px;
}

.spacing {
    margin-top: 10px;
}

.font_label {
    font-weight: bold;
    font-size: 18px;
}

.el-radio.is-bordered {
    width: 140px;
    padding: 12px 20px 0 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 40px;
}

/* 分页样式 */
.el-pager li {
    padding: 0 4px;
    font-size: 13px;
    min-width: 20.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
}
</style>
